import "./OutputDocuments.scss";

import { OutputDocumentsProvider } from "providers";
import { OutputDocumentsPanelProvider } from "providers";
import React from "react";

import { OutputDocumentsAgendaItem } from "./OutputDocumentsAgendaItem";
import { OutputDocumentsMeeting } from "./OutputDocumentsMeeting";

export const OutputDocuments: React.FC = () => {
  return (
    <OutputDocumentsProvider>
      <OutputDocumentsPanelProvider>
        <div className="d-flex">
          <div className="">
            <OutputDocumentsMeeting />
          </div>
          <div className="ms-3">
            <OutputDocumentsAgendaItem />
          </div>
        </div>
      </OutputDocumentsPanelProvider>
    </OutputDocumentsProvider>
  );
};
